import { AppointmentsContext } from "contexts/AppointmentsContext";
import { useContext } from "react";

const useAppointments = () => {
  return useContext(AppointmentsContext);
};

export default useAppointments;